const sideMargin = 30;
const FONT = 'Helvetica';
export const styles = {
  header: {
    boxSizing: 'border-box',
    color: '#fff',
    background: '#084171',
    height: 40,
    padding: '9px 0',
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: '10vw',
    paddingRight: '10vw',
    alignItems: 'center',
    marginBottom: 0,
    top: 0,
  },
  headerMobile: {
    boxSizing: 'border-box',
    color: '#fff',
    background: '#002060',
    height: 30,
    padding: '9px 1vw',
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: '0px',
    paddingRight: '0px',
    alignItems: 'center',
    marginBottom: 0,
    top: 0,
    justifyContent: 'center',
  },
  upHeader: {
    boxSizing: 'border-box',
    color: '#fff',
    background: '#001A33',
    height: '75px',
    padding: '9px 0',
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: '10vw',
    paddingRight: '10vw',
    alignItems: 'center',
    marginBottom: 0,
    top: 0,
  },
  upHeaderMobile: {
    boxSizing: 'border-box',
    color: '#fff',
    backgroundColor: '#001A33',
    height: '60px',
    padding: '5px 10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 0,
    top: 0,
  },
  upHeaderItem: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
  },
  logoImg: {
    width: '220px',
  },
  logoImgMobile: {
    height: '25px',
  },
  leftNav: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    cursor: 'pointer',
    marginLeft: sideMargin,
  },
  headerText: {
    fontFamily: 'Helvetica',
    color: '#696969',
    fontSize: 20,
    fontWeight: 400,
  },
  buttonWrapper: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  button: {
    color: 'white',
    textDecoration: 'none',
  },
  rightButton: {
    fontSize: 16,
    color: '#FFF',
    textDecoration: 'none',
    textTransform: 'none',
  },
  homeButton: {
    marginRight: '20px',
    fontSize: 16,
    color: '#FFF',
    textDecoration: 'none',
    textTransform: 'none',
  },
  headerBtnEnable: {
    width: '50%',
    fontSize: 14,
    color: '#FFF',
    backgroundColor: '#002060',
    textDecoration: 'none',
    textTransform: 'none',
    textAlign: 'center',
    paddingTop: '7px',
  },
  headerBtnDisable: {
    paddingTop: '7px',
    width: '50%',
    fontSize: 14,
    color: '#FFF',
    backgroundColor: '#A6A6A6',
    textDecoration: 'none',
    textTransform: 'none',
    textAlign: 'center',
  },
  hamburger: {
    marginRight: 0,
  },
  header_about: {
    fontSize: '17px',
    fontWeight: 'bold',
    color: 'white',
    background: '#0190E4',
    textDecoration: 'none',
    textTransform: 'none',
  },
  buttonWrapperTopMobile: {
    height: '30px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
  },
  topbtns: {
    backgroundColor: '#0190E4',
    color: 'white',
    textDecoration: 'none',
    fontSize: '17px',
    display: 'inline-block',
    fontWeight: 'bold',
    boxSizing: 'border-box',
    width: '100px',
    padding: '10px 0px',
    textAlign: 'center',
    marginRight: '20px',
  },
  topBarRight: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    cursor: 'pointer',
    alignItems: 'center',
  },
  playArrow: {
    color: 'white',
    marginRight: 10,
  },
  tickerInput: {
    width: '100%',
    height: 28,
    fontSize: 16,
    fontFamily: FONT,
    color: 'gray',
    // margin: "auto",
    textAlign: 'left',
    marginLeft: '40px',
    border: 'none',
    paddingLeft: '10px',
  },
  Gobutton: {
    backgroundColor: 'white',
    color: '#707f8f',
    padding: '0 10px',
    fontSize: '16px',
    height: '30px',
    border: 'none',
  },

  submenu: {
    textDecoration: 'none',
    color: 'black',
  },

  lockButton: {
    width: '18px',
    height: '20px',
    marginLeft: '8px',
    marginTop: '4px',
  },
  hoverDiv: {
    display: 'flex',
    // "&:hover": {
    //   background: "#efefef"
    // },
  },
};

export const useStyles = (theme) => ({
  root: {
    backgroundColor: 'red',
    height: '30px',
  },
  lable: {
    transform: 'translate(5px, 2px) scale(1)',
    pointerEvents: 'none',
    width: '100%',
    height: '100%',
    padding: '10px',
    color: 'red',
  },
  popover: {
    pointerEvents: 'none',
    color: 'pink',
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
  },
  paper: {
    // padding: theme.spacing(1),
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
  },
  popoverMobile: {
    color: 'pink',
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
  },
  paperMobile: {
    padding: theme.spacing(1),
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
  },
  etc: {
    color: 'red',
  },
});



// WEBPACK FOOTER //
// ./src/components/Header/index.styles.js